module.exports = __webpack_public_path__ + "static/img/isNoMessage.daf5b17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/isNoMessage.png
// module id = HXvk
// module chunks = 2